export const getSizeString = (width?: number, height?: number, ratio = 1) => {
  const widthString = width ? (width * ratio).toString() : ''
  const heightString = height ? (height * ratio).toString() : ''

  return `${widthString}x${heightString}`
}
